import React from 'react';

export default function TermsAndConditions() {
    return (
        <div style={{
            backgroundColor: '#f8f9fa',
            padding: '60px 20px',
            minHeight: '100vh',
            fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
        }}>
            <div style={{
                maxWidth: '900px',
                margin: '0 auto',
                backgroundColor: '#ffffff',
                padding: '40px 50px',
                borderRadius: '12px',
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                color: '#333333'
            }}>
                <div style={{ borderBottom: '2px solid #eaeaea', paddingBottom: '20px', marginBottom: '30px' }}>
                    <h1 style={{ color: '#1a1a1a', fontSize: '2.5rem', marginBottom: '10px' }}>Terms & Conditions</h1>
                    <p style={{ color: '#666', fontSize: '0.95rem' }}>Effective Date: July 23, 2026 | Kadtech HR Solutions</p>
                </div>
                
                <div style={{ lineHeight: '1.7', fontSize: '1rem', color: '#4a4a4a' }}>
                    <p style={{ marginBottom: '20px' }}>
                        Welcome to <strong>Kadtech HR Solutions</strong>. These Terms & Conditions ("Terms") govern your access to and use of our website, web application, and recruitment services. By accessing or using our platform, you explicitly agree to be bound by these Terms. If you do not agree with any part of these terms, please refrain from using our services.
                    </p>

                    <h2 style={{ color: '#2c3e50', fontSize: '1.4rem', marginTop: '30px', marginBottom: '15px' }}>1. Acceptance of Terms</h2>
                    <p style={{ marginBottom: '20px' }}>
                        By registering an account, submitting a resume, or browsing job postings on Kadtech HR Solutions, you confirm that you are at least 18 years of age and possess the legal authority to enter into a binding agreement.
                    </p>

                    <h2 style={{ color: '#2c3e50', fontSize: '1.4rem', marginTop: '30px', marginBottom: '15px' }}>2. User Accounts & Responsibilities</h2>
                    <p style={{ marginBottom: '15px' }}>
                        When you create an account with us, you agree to:
                    </p>
                    <ul style={{ paddingLeft: '20px', marginBottom: '20px' }}>
                        <li style={{ marginBottom: '10px' }}>Provide accurate, current, and complete information during registration and profile updates.</li>
                        <li style={{ marginBottom: '10px' }}>Maintain the strict confidentiality of your account credentials and password.</li>
                        <li style={{ marginBottom: '10px' }}>Accept full responsibility for all activities and job applications submitted under your user profile.</li>
                        <li style={{ marginBottom: '10px' }}>Promptly notify us of any unauthorized use or security breaches concerning your account.</li>
                    </ul>

                    <h2 style={{ color: '#2c3e50', fontSize: '1.4rem', marginTop: '30px', marginBottom: '15px' }}>3. Prohibited Conduct</h2>
                    <p style={{ marginBottom: '15px' }}>
                        Users are strictly prohibited from utilizing the platform to:
                    </p>
                    <ul style={{ paddingLeft: '20px', marginBottom: '20px' }}>
                        <li style={{ marginBottom: '10px' }}>Upload fraudulent, misleading, or plagiarized resumes or employment credentials.</li>
                        <li style={{ marginBottom: '10px' }}>Transmit malicious software, viruses, scripts, or harmful computer code.</li>
                        <li style={{ marginBottom: '10px' }}>Scrape, harvest, or extract data regarding other users or employers without explicit permission.</li>
                        <li style={{ marginBottom: '10px' }}>Engage in any activity that disrupts or interferes with the normal operation of the website.</li>
                    </ul>

                    <h2 style={{ color: '#2c3e50', fontSize: '1.4rem', marginTop: '30px', marginBottom: '15px' }}>4. Limitation of Liability</h2>
                    <p style={{ marginBottom: '20px' }}>
                        Kadtech HR Solutions acts as an intermediary platform connecting job seekers with prospective employers. We do not guarantee employment outcomes, interview schedules, or job placement. We shall not be held liable for any direct, indirect, incidental, or consequential damages arising from your use of our platform.
                    </p>

                    <h2 style={{ color: '#2c3e50', fontSize: '1.4rem', marginTop: '30px', marginBottom: '15px' }}>5. Contact Information</h2>
                    <p style={{ marginBottom: '10px' }}>
                        For inquiries regarding these Terms & Conditions, please contact us at:
                    </p>
                    <p style={{ fontWeight: '600', color: '#1a1a1a' }}>
                        Email: connect@kadtechhr.com <br />
                        Address: No. 11, 1st Floor, RT Nagar Main Road, Bangalore - 560032, Karnataka, India
                    </p>
                </div>
            </div>
        </div>
    );
}